






















































































































































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    options: Object,
  },
  data: () => ({
    menu: false,
    date: '',
    openDialog: false,
    // openDialog1: false,
    headers: [
      { text: 'Unidad', value: 'unidad.name' },
      { text: 'Id Unidad', value: 'unidad.id' },
      { text: 'Propietario', value: 'propietario.nombre' },
      { text: 'Id Propietario', value: 'propietario.id' },
      { text: 'Item', value: 'items[0].concepto.nombre' },
    ],
    recibos: [
      {
        unidad: { name: 'unidad 1', id: 1 },
        propietario: { name: 'propietario 1', id: 1 },
        items: [
        ],
        subtotal: 0,
        tipoDeComprobante: 'INGRESO',
        total: 0,
        fechaDeEmision: '',
        folio: '',
        serie: '',
        concepto: '',
      },
      {
        unidad: {name: 'unidad 2', id: 2 },
        propietario: {name: 'propietario 2', id: 2 },
        items: [],
        subtotal: 0,
        tipoDeComprobante: 'INGRESO',
        total: 0,
        fechaDeEmision: '',
        folio: '',
        serie: '',
        concepto: '',
      },
    ],
    items: [
    ],
    nuevoItem: {
    },
    nuevoConcepto: {
    },
    Recibo: {
      administracion: {},
      condominio: {},
      unidad: {},
      propietario: {},
      items: [],
      subtotal: 0,
      tipoDeComprobante: 'INGRESO',
      total: 0,
      fechaDeEmision: '',
      folio: '',
      serie: '',
    },
    loading: false,
    result: {},
    var: 0,
    conceptos: [],
    unidadesPropietarios: [],
    unidadPropietarioSeleccionado: {},
    recibo: {},
    conjuntoIndices: new Set(),
    arregloRecibos: [],
    total: 0,
    formatoFecha: 'MMM YYYY',
    time: '',
    i: '',
    precision: 2,
  }),
  computed: {
    computedDateFormatted() {
      return this.$moment(this.date).format(this.formatoFecha);
    },
    nuevoItemImporte() {
      if (!isNaN(this.nuevoItem.cantidad * this.nuevoItem.unitario)) {
        return (this.nuevoItem.cantidad * this.nuevoItem.unitario).toFixed(this.precision);
      } else {
        return (0).toFixed(this.precision);
      }
    },
    totalRecibo() {
      return this.Recibo.total.toFixed(this.precision);
    },
  },
  mounted() {
    this.loadData();
    this.date = this.$moment().format();
    this.time = this.$moment().format('HH:mm:ss');
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        const options = this.options;
        console.debug('datos: %o', datos);
        const result = await this.$store.dispatch('getUnidadesPropList', {datos, options});
        console.log('getUnidadesPropList: %o', result.content);
        this.unidadesPropietarios = result.content;
        for (const uniProp of this.unidadesPropietarios) {
          uniProp.etiqueta = uniProp.nombreUnidad + ' / ' + uniProp.nombreInquilino;
        }
        // this.total = result.totalElements;
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;

      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        const result = await this.$store.dispatch('getConceptoList1', {datos});
        this.conceptos = result.content;
        console.log('conceptos: %o', this.conceptos);
        // this.total = result.totalElements;
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    /* close() {
      this.openDialog1 = false;
      setTimeout(() => {
        this.nuevoItem = Object.assign({});
        this.nuevoItem.importe = 0;
      }, 300);
    }, */
    closeRecibo() {
      // this.Recibo = Object.assign({});
      this.openDialog = false;
      this.Recibo = {
        total: 0,
      };
      this.total = 0;
      this.items = Object.assign([]);
      this.date = this.$moment().format();
    },
/*    fecha() {   // FIXME Esto es igual que si fuera manual!
      const hora = this.$moment().hours();
      const min = this.$moment().minute();
      const seg = this.$moment().second();
      const isoFe = this.date + 'T' + hora + ':' + min + ':' + seg;
      this.Recibo.fechaDeEmision = this.$moment(isoFe).format();
      console.log('Fecha %o', this.Recibo.fechaDeEmision);
    },*/
    fecha() {
      this.Recibo.fechaDeEmision = this.$moment(this.date + ' ' + this.time).format();
      // console.log('Fecha: ', this.Recibo.fechaDeEmision);
    },
    AgregarConcepto() {
      this.nuevoItem.importe = this.nuevoItem.cantidad * this.nuevoItem.unitario;
      this.items.push(this.nuevoItem);
      this.total = this.items.length;
      this.items.forEach(this.getTotal);
      this.Recibo.total += this.var;
      // console.log('Total: %o', this.Recibo.total);
      // this.modeloRecibo();
      this.close();
    },
    AgregarConceptoG() {
      this.nuevoItem = this.modeloItem();
      this.nuevoItem.concepto = this.nuevoConcepto;
      for (const recibo of this.arregloRecibos) {
        recibo.items.push(this.nuevoItem);
      }

      console.log('imprime hola', this.arregloRecibos);
    },
    getTotal(item, index) {
      // console.log('ITEM: %o', item);
      this.var = item.importe;
    },
    async AgregarRecibo() {
      try {
        this.loading = true;
        this.Recibo.administracion = this.$store.getters.getAdmin;
        this.Recibo.condominio = this.$store.getters.getCondo;
        this.Recibo.items = this.items;
        this.fecha();
        const result = await this.$store.dispatch('addRecibo', {datos: this.Recibo});
        this.$toast.success('Recibo Agregado exitosamente');
        console.log('Recibo: %o', this.Recibo);
        // console.log('Recibo: %o', this.Recibo);
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
      this.closeRecibo();
      this.loading = false;
      // this.unidadSeleccionada = {};
      this.$emit('reload', {});
    },
/*    formatDate(fecha) {
      if (!fecha) {
        return null;
      }
      const [year, month, day] = fecha.split('-');  // FIXME Esto es igual que si fuera manual!
      return `${day} - ${month} - ${year}`;         // FIXME donde esta el mixin? this.$moment...
    },*/
    rowSelected(event) {
      console.log('EVENTO: %o', event);
    },
    AgregarUnidadPropietario() {
      console.log('AgregarUnidadPropietario');
      if ((this.unidadPropietarioSeleccionado.unidadId + 1)
          && (this.unidadPropietarioSeleccionado.propId + 1)) {
        const indices = 'u' + this.unidadPropietarioSeleccionado.unidadId
          + 'p' + this.unidadPropietarioSeleccionado.propId;
        // console.log('indices %o', indices);
        // console.log('conjuntoIndices %o', this.conjuntoIndices);
        if (!this.conjuntoIndices.has(indices)) {
          this.conjuntoIndices.add(indices);
          this.recibo = this.modeloRecibo();
          this.recibo.unidad.id = this.unidadPropietarioSeleccionado.unidadId;
          this.recibo.unidad.name = this.unidadPropietarioSeleccionado.nombreUnidad;
          this.recibo.propietario.id = this.unidadPropietarioSeleccionado.propId;
          this.recibo.propietario.nombre = this.unidadPropietarioSeleccionado.nombreInquilino;
          this.arregloRecibos.push(this.recibo);
        }
        // console.log('recibo: %o', this.recibo);
        // console.log('arregloRecibos: %o', this.arregloRecibos);
      }
    },
    QuitarUnidadPropietario(event) {
      console.log('QuitarUnidadPropietario');
      if (event.id && event.name) {
        /* this.conjuntoUnidades.delete(event);
        this.arregloUnidades = Array.from(this.conjuntoUnidades); */
      }
    },
    modeloRecibo() {
      return {
        /* fechaDeEmision: '',
        folio: 0,
        id: 0, */
        items: [
        ],
        propietario: {
          id: 0,
          nombre: '',
        },
        /* serie: '',
        subtotal: 0,
        tipoDeComprobante: true,
        total: 0, */
        unidad: {
          id: 0,
          name: '',
        },
      };
    },
    modeloItem() {
      return {
        cantidad: 0,
        concepto: {
          creationDateTime: '',
          creationUsername: '',
          ctaContable: '',
          descripcion: '',
          id: 0,
          lastModificationDateTime: '',
          lastModificationUsername: '',
          nombre: '',
          observaciones: '',
          tipo: 'INGRESO',
        },
        descripcion: '',
        id: 0,
        importe: 0,
        unidadDeMedida: '',
        unitario: 0,
      };
    },
  },
  watch: {
    selected() {
      console.log('watch selected: %o', this.selected);
    },
  },
});
